import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, TrendingUp, CalendarCheck } from 'lucide-react';
const pillars = [{
  icon: ShieldCheck,
  title: 'Claridad desde el primer día',
  description: 'Evaluamos el estado real del terreno o de tu construcción actual para decirte qué es posible y cómo lograrlo con éxito.'
}, {
  icon: TrendingUp,
  title: 'Control Previo de Presupuesto',
  description: 'Sin sobrecostos injustificados.'
}, {
  icon: CalendarCheck,
  title: 'Garantía de Entrega en Tiempos',
  description: 'Cumplimiento estricto del cronograma pactado.'
}];
export function ValueProposition() {
  return <section className="py-24 md:py-32 pb-32 bg-gerfaj-blue relative overflow-hidden" data-id="element-20">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gerfaj-orange rounded-full mix-blend-multiply filter blur-3xl opacity-20 translate-x-1/2 -translate-y-1/2" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 -translate-x-1/2 translate-y-1/2" data-id="element-22"></div>

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-24">
          <h2 className="text-3xl md:text-5xl font-montserrat font-bold text-white leading-tight mb-6 max-w-4xl mx-auto" data-id="element-25">
            Disfruta la evolución de tu obra con la tranquilidad de haber tomado
            la <span className="text-gerfaj-orange" data-id="element-26">decisión correcta</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-27">
            En Gerfaj no solo construimos; aseguramos el cuidado de tu
            patrimonio con absoluta honestidad.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-28">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1 * index
        }} className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-8 text-center hover:border-gerfaj-orange/30 transition-colors duration-300" data-id="element-29">
              <div className="w-16 h-16 rounded-2xl bg-gerfaj-orange/15 border border-gerfaj-orange/30 flex items-center justify-center mx-auto mb-6" data-id="element-30">
                <pillar.icon className="w-9 h-9 text-gerfaj-orange" data-id="element-31" />
              </div>
              <h3 className="text-xl font-montserrat font-bold text-white mb-3" data-id="element-32">
                {pillar.title}
              </h3>
              <p className="text-gray-300 leading-relaxed text-sm md:text-base" data-id="element-33">
                {pillar.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}